<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">CONTENTS</p>
<p class="toc1"><a href="#/Preface">Preface</a></p>
<p class="toc"><a href="#/Acknowledgements">Acknowledgements</a></p>
<p class="toc1"><a href="#/Chapter1#C1">1. Back in the Day: A Flyover History of Fairfield</a></p>
<p class="toc"><span href="#/Chapter2#C2" title="Link target outside of Sample">2. Up in the Morning and Out to School</span></p>
<p class="toc"><span href="#/Chapter3#C3" title="Link target outside of Sample">3. What Do You Do for Fun around Here?</span></p>
<p class="toc"><span href="#/Chapter4#C4" title="Link target outside of Sample">4. Famous Fairfielders and Famous Fairfield Visitors</span></p>
<p class="toc"><span href="#/Chapter5#C5" title="Link target outside of Sample">5. Solano County Seat Landmarks</span></p>
<p class="toc"><span href="#/Chapter6#C6" title="Link target outside of Sample">6. Uniquely Fairfield Stories</span></p>
<p class="toc"><span href="#/Chapter7#C7" title="Link target outside of Sample">7. Let’s Eat!</span></p>
<p class="toc"><span href="#/Chapter8#C8" title="Link target outside of Sample">8. Fairfield on Film: The Good, the Bad, the Ugly and… Well, the Dirty</span></p>
<p class="toc"><span href="#/Chapter9#C9" title="Link target outside of Sample">9. Removing the Rose-Colored Glasses</span></p>
<p class="toc"><span href="#/Chapter10#C10" title="Link target outside of Sample">10. Where Is Fairfield?</span></p>
<p class="toc1"><span href="#/Bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/Author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?da883100